import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";

import { capitalizeFirstLetter } from "../../../../../utils/stringFunctions";
import { ContentState, getContentStatusString } from "../../../../../models/SKArtifact";
import { Link } from "react-router-dom";

interface ContentHistoryNavigatorProps {
  title?: string;
  contentStatus?: ContentState;
  contentId: string;
}

export default function ContentHistoryNavigator({ title, contentStatus, contentId }: ContentHistoryNavigatorProps) {
  const { contentData, updateContentData } = useContext(CreateArtifactContext);
  const [imgSrc, setImgSrc] = useState<string>("/icons/Addsign.png");
  const navigate = useNavigate();

  return (
    <div className="relative w-full min-w-[200px] ">
      <div className="flex items-center pb-[10px]">
        <span className="content_title">{title}</span>
      </div>
      <div
        id="content-item"
        className="cursor-pointer input-content-topic"
        tabIndex={0}
        // onClick={() => {
        //   contentId && navigate("../history", { state: { channelId: contentId } });
        // }}
      >
        <Link to={`history`} className="flex items-center justify-between w-full">
          <div id="topic" className="flex input-content-topic-text">
            View Status History
          </div>

          <div id="title" className="flex m-[15px]">
            <div className="input-content-topic-title">{getContentStatusString(contentData.status, contentData.subStatus, true)}</div>
          </div>
        </Link>
      </div>
    </div>
  );
}
